import IntersectionObserverWrapper from './intersection-observer-wrapper.component'

export default IntersectionObserverWrapper
